"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_truncate_1 = tslib_1.__importDefault(require("react-truncate"));
/**
 * @public
 */
var InsightTitle = function (_a) {
    var title = _a.title;
    return (react_1.default.createElement("div", { className: "insight-title-outer" },
        react_1.default.createElement("div", { className: "insight-title" },
            react_1.default.createElement(react_truncate_1.default, { lines: 2, ellipsis: "...", className: "item-headline-inner s-headline" }, title))));
};
exports.default = InsightTitle;
//# sourceMappingURL=InsightTitle.js.map